import GenerateAPI from '../generate.js'

const config = {
    getOpenId: {
        url: '/client/wx/getOpenId',
        apiType: 'check',
    },
    userBind: {
        url: '/client/wx/bing',
    },

    cancelUserBind: {
        url: '/client/wx/cancelBing',
    },
    listPerson: {
        url: '/client/wx/listPerson',
        apiType: 'check',
    },
    changePerson: {
        url: '/client/wx/changePerson',
        apiType: 'check',
    },
    deletePerson: {
        url: '/client/wx/deletePerson',
        apiType: 'check',
    },
}

const apiUserPage = GenerateAPI.generate(config)
export default apiUserPage
